import React from 'react'
import { connectModal } from 'redux-modal'
import { Button, Modal } from 'antd'
import { FormattedMessage } from 'react-intl.macro'

const CheckOutErrorModal = (props) => {

  const {show} = props
    // reload page with handleReload
  const handleReload = () => {
      window.location.reload()
  }

  return (
    <Modal
      title={ null }
      footer={ null }
      maskClosable={ false }
      closable={ false }
      wrapClassName='vpt-error-modal'
      visible={ show }
      onOk={ handleReload }
          onCancel={handleReload }
    >
      {
        <div className='text-center vpt-form'>
            <div className='g-mb-15'>
            <FormattedMessage
                id="Order.CDP.Error.Message"
                defaultMessage='Xin lỗi, hiện tại hệ thống không thể hoàn tất yêu cầu của bạn. Vui lòng thử lại sau hoặc liên hệ tổng đài để được hỗ trợ.'
                />
            </div>
            <Button
            className='g-bg-primary g-brd-primary g-color-white'
              onClick={handleReload }
            >
            <FormattedMessage
                id="Order.Hotel.Fail.Repayment"
                defaultMessage='Thanh toán lại'
            />
            </Button>
        </div>
      }
    </Modal>
  )
}


export default connectModal ({name: 'checkOutErrorModal', destroyOnHide: true}) (CheckOutErrorModal)
